export default () => (
    {
        isDarkMode: false,

        init(){
            // Set theme on load
            this.setTheme();
        },

        setTheme() {
            // Must add .dark class to the html element
            const html = document.querySelector("html");
            var prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

            // Check and apply the user's stored preference if available.
            // Otherwise use the system preference.
            if (!("theme" in localStorage) && prefersDark) {
                this.isDarkMode = true;
                html.classList.add("dark");
            } else if (localStorage.theme === "dark") {
                this.isDarkMode = true;
                html.classList.add("dark");
            } else {
                this.isDarkMode = false;
                html.classList.remove("dark");
            }

            // Add the theme preference to the user's local storage
            localStorage.theme = this.isDarkMode ? "dark" : "light";
            document.cookie = `grwdb_theme_preference=${this.isDarkMode ? 'dark' : 'light'}; path=/; max-age=9999999; SameSite=Lax`;
        },

        toggleTheme() {
            this.isDarkMode = ! this.isDarkMode;
            const html = document.querySelector("html");

            if (this.isDarkMode) {
                html.classList.add("dark");
            }
            else {
                html.classList.remove("dark");
            }

            // Add the theme preference to the user's local storage
            localStorage.theme = this.isDarkMode ? "dark" : "light";
            document.cookie = `grwdb_theme_preference=${this.isDarkMode ? 'dark' : 'light'}; path=/; max-age=9999999; SameSite=Lax`;
        },
    }
);